// ==========================
// src/components/CookieBanner.jsx (versión simplificada: solo cookies técnicas)
// ==========================
import React, { useEffect, useState } from 'react';
import { Paper, Container, Stack, Typography, Button, Link as MLink } from '@mui/material';

const LS_KEY = 'cookie-consent-v1';

export default function CookieBanner(){
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const has = localStorage.getItem(LS_KEY);
      if (!has) setOpen(true);
    } catch {
      setOpen(true);
    }
  }, []);

  // Permitir reabrir el aviso desde el footer
  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener('cookie:show-banner', handler);
    return () => window.removeEventListener('cookie:show-banner', handler);
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(LS_KEY, JSON.stringify({ necessary: true, date: new Date().toISOString() }));
    } catch {}
    setOpen(false);
  };

  if (!open) return null;

  return (
    <Paper elevation={6} sx={{ position:'fixed', left:16, right:16, bottom:16, zIndex:1300, p:2, border:'1px solid #eee' }}>
      <Container sx={{ display:'flex', flexDirection:{ xs:'column', md:'row' }, alignItems:{ md:'center' }, gap:1.5 }}>
        <Typography variant="body2" sx={{ flex:1 }}>
          Usamos únicamente <strong>cookies técnicas necesarias</strong> para el funcionamiento del sitio. No usamos cookies de analítica ni de marketing. Más información en{' '}
          <MLink href="#privacidad" underline="always">Privacidad y cookies</MLink>.
        </Typography>
        <Stack direction={{ xs:'column', md:'row' }} spacing={1}>
          <Button variant="contained" onClick={accept}>Entendido</Button>
        </Stack>
      </Container>
    </Paper>
  );
}